import React from 'react'
import useLocaleText from 'components/useLocaleText'
import styles from './styles.module.css'

const literals = {
  title: {
    key: 'tasks_execution_all_subtasks_done',
    fallback: { en: 'All subtasks completed!', he: 'כל תת־המשימות הושלמו!' },
  },
  hint: {
    key: 'tasks_execution_ready_to_complete',
    fallback: { en: 'Great work. You’re ready to complete this task.', he: 'כל הכבוד. אפשר כעת להשלים את המשימה.' },
  },
}

export function ExecutionCompleteState({ action }: { action: React.ReactNode }) {
  const t = useLocaleText(literals)

  return (
    <div className={styles.state}>
      <svg className={styles.illustration} viewBox="0 0 320 190" fill="none" aria-hidden="true">
        <ellipse cx="160" cy="164" rx="95" ry="11" fill="#f2f4f6" />
        <rect
          x="85"
          y="28"
          width="160"
          height="121"
          rx="16"
          fill="#fafbfc"
          stroke="#e3e7eb"
          transform="rotate(7 165 89)"
        />
        <rect x="75" y="46" width="170" height="114" rx="16" fill="white" stroke="#dce2e7" />
        <circle cx="160" cy="91" r="28" fill="#def4ea" />
        <path d="m147 91 9 9 18-19" stroke="#43866b" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M131 134h58" stroke="#e4e8ed" strokeWidth="6" strokeLinecap="round" />
        <path d="m55 61-7-8m19 66-10 4m208-30 10-4m-26-46 6-9" stroke="#c1dce9" strokeWidth="5" strokeLinecap="round" />
        <path d="m103 18-4-7m182 121 5 7M206 18l5-8" stroke="#eacada" strokeWidth="5" strokeLinecap="round" />
        <circle cx="41" cy="90" r="4" fill="#c3e8d9" />
        <circle cx="278" cy="57" r="4" fill="#c3e8d9" />
        <path d="m67 23 2 6 6 2-6 2-2 6-2-6-6-2 6-2Zm218 129 2 6 6 2-6 2-2 6-2-6-6-2 6-2Z" fill="#dfcfa7" />
      </svg>
      <div role="status">
        <h2>{t.title}</h2>
        {action && <p>{t.hint}</p>}
      </div>
      {action}
    </div>
  )
}
